module.exports = __webpack_public_path__ + "img/197.bca62b2a.jpg";